import Avatar from '@mui/material/Avatar';
import { blue } from '@mui/material/colors';

interface AccountAvatarProps {
  name?: string;
  src?: string;
}

export default function AccountAvatar({ name, src }: AccountAvatarProps) {
  return (
    <Avatar
      src={src}
      alt={name}
      sx={{ backgroundColor: () => blue[700] }}
    ></Avatar>
  );
}
